import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import dayjs from 'dayjs'
import dayjsBusinessTime from 'dayjs-business-time';
dayjs.extend(dayjsBusinessTime);
import ky from 'ky';
import IMask from 'imask';
import validator from 'validator';
import Swal from 'sweetalert2';

export default class extends Controller {
  static targets = ['bookButton', 'reservationModal', 'reservationModalForm', 'start_location', 'end_location', 'bookingForm']
  static values = {
    url: Boolean
  }

  connect() {
    console.log("reservation controller connected");
    flatpickr("#start_date", {
      locale: Russian,
      date_format: "d-m-Y",
      minDate: new Date(),
      altInput: true,
      altFormat: "d-m-Y",
      altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
      disableMobile: "true",
    });
    flatpickr("#start_time", {
      locale: Russian,
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
      disableMobile: "true",
    });
    flatpickr("#end_date", {
      locale: Russian,
      date_format: "d-m-Y",
      minDate: new Date(),
      altInput: true,
      altFormat: "d-m-Y",
      altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
      disableMobile: "true",
    });
    flatpickr("#end_time", {
      locale: Russian,
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
      disableMobile: "true",
    });

    var dateMask = IMask(
      document.getElementById('birthday'),
      {
        mask: Date,
        min: new Date(1900, 0, 1),
        max: new Date(2100, 0, 1),
        isContentEditable: true,
        lazy: false
      }
    );
    // var driverFromMask = IMask(
    //   document.getElementById('driver_from'),
    //   {
    //     mask: Date,
    //     min: new Date(1900, 0, 1),
    //     max: new Date(2100, 0, 1),
    //     isContentEditable: true,
    //     lazy: false
    //   }
    // );
    var phoneMask = IMask(
      document.getElementById('phone'), {
      mask: '+{7}(000)000-00-00'
    });
    var phoneExternalMask = IMask(
      document.getElementById('phone_external'), {
      mask: '+0(000)000-000-00'
    });

    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);

    document.getElementById("errors").classList.add("hidden");
    document.getElementById("datepickers").classList.remove("border-2", "border-red-600");
    this.bookButtonTarget.disabled = false;
    if (!car.free) {
      document.getElementById("datepickers").classList.add("border-2", "border-red-600");
      document.getElementById("errors").classList.remove("hidden");
      document.getElementById("message").innerText = "Выбранный вами период времени занят";
      this.bookButtonTarget.disabled = true;
    }

    let start_date = document.getElementById("start_date").value;
    let end_date = document.getElementById("end_date").value;
    let start_time = document.getElementById("start_time").value;
    let end_time = document.getElementById("end_time").value;
    let start_date_full = `${start_date} ${start_time}`;
    let end_date_full = `${end_date} ${end_time}`;
    let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;

    document.getElementById("selected_price").innerText = car.selected_price;
    document.getElementById("nights").innerText = car.all_days;
    document.getElementById("deposit").innerText = car.deposit;
    document.getElementById("modal_deposit").innerText = car.deposit;
    document.getElementById("for_rent").innerText = parseInt(car.selected_price) * parseInt(car.all_days);
    document.getElementById("modal_for_rent").innerText = parseInt(car.selected_price) * parseInt(car.all_days);
    document.getElementById("total").innerText = parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit));
    document.getElementById("modal_total").innerText = parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit));
    console.log("total", parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit)));
    document.getElementById("to_pay").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) * 0.1);
    document.getElementById("to_pay_now").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) * 0.1);

    // Скидка за длительность аренды
    this.discount_for_day = car.start_price - car.selected_price;
    this.full_discount = (car.start_price - car.selected_price) * car.all_days;
    document.getElementById("price_discount_block").classList.remove("hidden");
    if (this.discount_for_day > 0) {
      document.getElementById("price_with_discount").classList.remove("hidden");
      document.getElementById("price_without_discount").classList.add("hidden");
      // document.getElementById("discounts").classList.remove("hidden");
      // document.getElementById("modal_discounts").classList.remove("hidden");
      document.getElementById("price_with_discount_value").innerText = ` ${car.selected_price}₽`;
      document.getElementById("discount").innerText = this.discount_for_day;
      document.getElementById("full_discount").innerText = this.discount_for_day * car.all_days;
      document.getElementById("modal_discount").innerText = this.discount_for_day;
      document.getElementById("modal_full_discount").innerText = this.discount_for_day * car.all_days;
      document.getElementById("discount_days").innerText = car.all_days;
      document.getElementById("modal_discount_days").innerText = car.all_days;
    } else {
      document.getElementById("price_with_discount").classList.add("hidden");
      document.getElementById("price_without_discount").classList.remove("hidden");
      // document.getElementById("discounts").classList.add("hidden");
      // document.getElementById("modal_discounts").classList.add("hidden");
      document.getElementById("price_without_discount_value").innerText = ` ${car.selected_price}₽`;
      document.getElementById("discount").innerText = 0;
      document.getElementById("full_discount").innerText = 0;
      document.getElementById("modal_discount").innerText = 0;
      document.getElementById("modal_full_discount").innerText = 0;
      document.getElementById("discount_days").innerText = 0;
      document.getElementById("modal_discount_days").innerText = 0;
    }
    // Hours
    if (hours > 0 && hours < car.hours_limit) {
      document.getElementById("hours_calc").classList.remove("hidden");
      document.getElementById("price_hour").innerText = car.price_hour;
      document.getElementById("paid_hours").innerText = hours;
      document.getElementById("for_paid_hours").innerText = car.price_hour * hours;
      document.getElementById("total").innerText = parseInt(parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit) + (car.price_hour * hours)));
      document.getElementById("modal_total").innerText = parseInt(parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit) + (car.price_hour * hours)));
    }

    // Рабочее время
    // Create your Business Week definition
    const business_time = car.booking_settings.business_time
    // Set Business Times in dayjs
    dayjs.setBusinessTime(business_time);

    if (!(dayjs(start_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
      let start_location
      let start_location_name = document.getElementById("start_location").value
      if (start_location_name != "") {

        start_location = this.locations(car).find((item) => item.name == start_location_name)
      } else {
        start_location = this.locations(car).find((item) => item.name == "Офис")
      }
      const start_surcharge = this.applyAfterHoursSurcharge(start_location, "modal_for_location_start", "modal_for_location_start_price");
      document.getElementById("modal_total").innerText = parseInt(document.getElementById("modal_total").textContent) + start_surcharge;
    }
    if (!(dayjs(end_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
      let end_location
      let end_location_name = document.getElementById("end_location").value
      if (end_location_name != "") {

        end_location = this.locations(car).find((item) => item.name == end_location_name)
      } else {
        end_location = this.locations(car).find((item) => item.name == "Офис")
      }
      const end_surcharge = this.applyAfterHoursSurcharge(end_location, "modal_for_location_end", "modal_for_location_end_price");
      document.getElementById("modal_total").innerText = parseInt(document.getElementById("modal_total").textContent) + end_surcharge;
    }

    // Сброс доп услуг
    let services = document.querySelectorAll(".service");
    if (services.length > 0) {
      services.forEach((service) => {
        service.checked = false;
      });
    } else {
      document.getElementById("modal_services_total").classList.add("hidden");
      document.getElementById("modal_services").classList.add("hidden");
    }

    // Если есть партнерский код, то открываем модалку
    var search_params = new URLSearchParams(window.location.search)
    if (search_params.has('from_partner')) {
      this.open(false);
    }

  }
  change() {
    console.log("reservation controller change");
    document.getElementById("payment_info_loaders").classList.remove("hidden");
    document.getElementById("payment_info").classList.add("hidden");

    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    let start_date = document.getElementById("start_date").value;
    let end_date = document.getElementById("end_date").value;
    let start_time = document.getElementById("start_time").value;
    let end_time = document.getElementById("end_time").value;
    let start_date_full = `${start_date} ${start_time}`;
    let end_date_full = `${end_date} ${end_time}`;
    var search_params = new URLSearchParams(window.location.search)
    search_params.set('start_date', dayjs(start_date_full, "YYYY-MM-DD H:mm").format("DD-MM-YYYY H:mm"));
    search_params.set('end_date', dayjs(end_date_full, "YYYY-MM-DD H:mm").format("DD-MM-YYYY H:mm"));
    window.history.replaceState(null, null, `/cars/${car.id}?${search_params.toString()}`);
    let check_start_before_end = dayjs(start_date_full, "YYYY-MM-DD H:mm").isBefore(dayjs(end_date_full, "YYYY-MM-DD H:mm"));
    if (start_date && end_date && start_time && end_time && check_start_before_end) {
      let url = `https://rentprog.net/api/v1/show_car`
      if (document.querySelector('meta[name="environment"]').content == "development") {
        url = `http://localhost:3000/api/v1/show_car`
      }
      const response = ky.post(url, {
        json: {
          id: car.id,
          start_date: start_date_full,
          end_date: end_date_full,
        },
        hooks: {
          beforeError: [
            error => {
              const { response } = error;
              if (response && response.body) {
                error.name = 'Loading Error';
                error.message = `${response.body.message} (${response.status})`;
              }
              document.getElementById("payment_info_loaders").classList.add("hidden");
              document.getElementById("payment_info").classList.remove("hidden");
              console.log(error);
              alert(error);
            }
          ]
        },
        retry: 0
      });
      response.then((data) => {
        data.json().then((json) => {
          let car = json;
          document.getElementById("errors").classList.add("hidden");
          document.getElementById("datepickers").classList.remove("border-2", "border-red-600");
          this.bookButtonTarget.disabled = false;
          if (!car.free) {
            document.getElementById("datepickers").classList.add("border-2", "border-red-600");
            document.getElementById("errors").classList.remove("hidden");
            document.getElementById("message").innerText = "Выбранный вами период времени занят";
            this.bookButtonTarget.disabled = true;
          }
          let start_date = document.getElementById("start_date").value;
          let end_date = document.getElementById("end_date").value;
          let start_time = document.getElementById("start_time").value;
          let end_time = document.getElementById("end_time").value;
          let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;

          document.getElementById("reservation_form").dataset.car = JSON.stringify(car);

          document.getElementById("selected_price").innerText = car.selected_price;
          document.getElementById("nights").innerText = car.all_days;
          document.getElementById("total").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) + parseInt(car.deposit));
          document.getElementById("modal_total").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) + parseInt(car.deposit));
          document.getElementById("to_pay").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) * 0.1);
          document.getElementById("to_pay_now").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) * 0.1);
          // document.getElementById("for_rent").innerText = parseInt(parseInt(car.selected_price) * parseInt(car.all_days) + parseInt(car.deposit) - (parseInt(parseInt(car.selected_price) * parseInt(car.all_days) * 0.1)))
          document.getElementById("for_rent").innerText = parseInt(car.selected_price) * parseInt(car.all_days)

          // Обнуляем часы
          document.getElementById("hours_calc").classList.add("hidden");
          document.getElementById("price_hour").innerText = 0;
          document.getElementById("paid_hours").innerText = 0;
          document.getElementById("for_paid_hours").innerText = 0;
          document.getElementById("modal_hours_calc").classList.add("hidden");
          document.getElementById("modal_price_hour").innerText = 0;
          document.getElementById("modal_paid_hours").innerText = 0;
          document.getElementById("modal_for_paid_hours").innerText = 0;

          // Скидка за длительность аренды
          this.discount_for_day = car.start_price - car.selected_price;
          this.full_discount = (car.start_price - car.selected_price) * car.all_days;
          document.getElementById("price_discount_block").classList.remove("hidden");
          if (this.discount_for_day > 0) {
            document.getElementById("price_with_discount").classList.remove("hidden");
            document.getElementById("price_without_discount").classList.add("hidden");
            // document.getElementById("discounts").classList.remove("hidden");
            // document.getElementById("modal_discounts").classList.remove("hidden");
            document.getElementById("price_with_discount_value").innerText = ` ${car.selected_price}₽`;
            document.getElementById("discount").innerText = this.discount_for_day;
            document.getElementById("full_discount").innerText = this.discount_for_day * car.all_days;
            document.getElementById("modal_discount").innerText = this.discount_for_day;
            document.getElementById("modal_full_discount").innerText = this.discount_for_day * car.all_days;
            document.getElementById("discount_days").innerText = car.all_days;
            document.getElementById("modal_discount_days").innerText = car.all_days;
          } else {
            document.getElementById("price_with_discount").classList.add("hidden");
            document.getElementById("price_without_discount").classList.remove("hidden");
            // document.getElementById("discounts").classList.add("hidden");
            // document.getElementById("modal_discounts").classList.add("hidden");
            document.getElementById("price_without_discount_value").innerText = ` ${car.selected_price}₽`;
            document.getElementById("discount").innerText = 0;
            document.getElementById("full_discount").innerText = 0;
            document.getElementById("modal_discount").innerText = 0;
            document.getElementById("modal_full_discount").innerText = 0;
            document.getElementById("discount_days").innerText = 0;
            document.getElementById("modal_discount_days").innerText = 0;
          }

          if (hours > 0 && hours < car.hours_limit) {
            document.getElementById("hours_calc").classList.remove("hidden");
            document.getElementById("price_hour").innerText = car.price_hour;
            document.getElementById("paid_hours").innerText = hours;
            document.getElementById("for_paid_hours").innerText = car.price_hour * hours;
            document.getElementById("total").innerText = parseInt(parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit) + (car.price_hour * hours)));
            document.getElementById("modal_hours_calc").classList.remove("hidden");
            document.getElementById("modal_price_hour").innerText = car.price_hour;
            document.getElementById("modal_paid_hours").innerText = hours;
            document.getElementById("modal_for_paid_hours").innerText = car.price_hour * hours;
            document.getElementById("modal_total").innerText = parseInt(parseInt((parseInt(car.selected_price) * parseInt(car.all_days)) + parseInt(car.deposit) + (car.price_hour * hours)));
          }

          // Меняем даты в модалке
          document.getElementById("city_start_date").innerText = dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm").format("DD-MM-YYYY H:mm");
          document.getElementById("city_end_date").innerText = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").format("DD-MM-YYYY H:mm");


          // Рабочее время
          // Create your Business Week definition
          const business_time = car.booking_settings.business_time
          // Set Business Times in dayjs
          dayjs.setBusinessTime(business_time);

          if (!(dayjs(start_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
            let start_location_id = document.getElementById("start_location").value
            let start_location = this.locations(car).find((item) => item.id == start_location_id)
            const start_surcharge = this.applyAfterHoursSurcharge(start_location, "modal_for_location_start", "modal_for_location_start_price");
            document.getElementById("modal_total").innerText = parseInt(document.getElementById("modal_total").textContent) + start_surcharge;
          }
          if (!(dayjs(end_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
            let end_location_id = document.getElementById("end_location").value
            let end_location = this.locations(car).find((item) => item.id == end_location_id)
            const end_surcharge = this.applyAfterHoursSurcharge(end_location, "modal_for_location_end", "modal_for_location_end_price");
            document.getElementById("modal_total").innerText = parseInt(document.getElementById("modal_total").textContent) + end_surcharge;
          }
        });
        document.getElementById("payment_info_loaders").classList.toggle("hidden");
        document.getElementById("payment_info").classList.toggle("hidden");
      });
    }
  }
  changeStartDate() {
    let min_date = document.getElementById("start_date").value;
    flatpickr("#end_date", {
      locale: Russian,
      date_format: "d-m-Y",
      minDate: min_date ? dayjs(min_date, "YYYY-MM-DD").add(1, 'day').toDate() : new Date(),
      altInput: true,
      altFormat: "d-m-Y",
      altInputClass: "block w-full border-y-0 border-l-0 border-r border-gray-800 text-gray-800 placeholder-gray-500 focus:ring-0 text-base",
      disableMobile: "true",
    });
    this.change()
  }
  selectStartLocation() {
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    let start_date = document.getElementById("start_date").value;
    let end_date = document.getElementById("end_date").value;
    let start_time = document.getElementById("start_time").value;
    let end_time = document.getElementById("end_time").value;
    let start_date_full = `${start_date} ${start_time}`;

    let rental_cost = parseInt(document.getElementById("modal_total").textContent) - parseInt(document.getElementById("modal_for_location_start_price").textContent || 0);
    console.log("modal_total 3 rental_cost", rental_cost)
    // Рабочее время
    const business_time = car.booking_settings.business_time
    dayjs.setBusinessTime(business_time);

    let start_location_name = document.getElementById("start_location").value
    let start_location = this.locations(car).find((item) => item.name == start_location_name)

    let end_location_price = 0
    if (document.getElementById("modal_for_location_end_price").textContent) {
      end_location_price = parseInt(document.getElementById("modal_for_location_end_price").textContent)
    }
    if (!(dayjs(start_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
      const start_surcharge = this.applyAfterHoursSurcharge(start_location, "modal_for_location_start", "modal_for_location_start_price");

      document.getElementById("modal_total").innerText = parseInt(rental_cost + start_surcharge);
    } else {
      if (start_location && parseInt(start_location.price) > 0) {
        document.getElementById("modal_for_location_start").classList.remove("hidden");
        document.getElementById("modal_for_location_start_price").innerText = start_location.price;

        document.getElementById("modal_total").innerText = parseInt(rental_cost + parseInt(start_location.price));
        console.log("modal_total 1", rental_cost + parseInt(start_location.price))
        // Прибавляло цену за часы при изменении локации хотя уже были
        // let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;
        // if (hours > 0 && hours < car.hours_limit) {
        //   document.getElementById("modal_total").innerText = parseInt(rental_cost + (car.price_hour * hours) + parseInt(start_location.price));
        // }
      } else {
        document.getElementById("modal_for_location_start").classList.add("hidden");
        document.getElementById("modal_for_location_start_price").innerText = 0;
        document.getElementById("modal_total").innerText = parseInt(rental_cost);

        // let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;
        // if (hours > 0 && hours < car.hours_limit) {
        //   document.getElementById("modal_total").innerText = parseInt(rental_cost + (car.price_hour * hours));
        // }
      }
    }
  }
  selectEndLocation() {
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    let start_date = document.getElementById("start_date").value;
    let end_date = document.getElementById("end_date").value;
    let start_time = document.getElementById("start_time").value;
    let end_time = document.getElementById("end_time").value;
    let end_date_full = `${end_date} ${end_time}`;

    let rental_cost = parseInt(document.getElementById("modal_total").textContent) - parseInt(document.getElementById("modal_for_location_end_price").textContent || 0);
    // Рабочее время
    const business_time = car.booking_settings.business_time
    dayjs.setBusinessTime(business_time);

    let end_location_name = document.getElementById("end_location").value
    let end_location = this.locations(car).find((item) => item.name == end_location_name)

    let start_location_price = 0
    if (document.getElementById("modal_for_location_start_price").textContent) {
      start_location_price = parseInt(document.getElementById("modal_for_location_start_price").textContent)
    }

    if (!(dayjs(end_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
      const end_surcharge = this.applyAfterHoursSurcharge(end_location, "modal_for_location_end", "modal_for_location_end_price");

      document.getElementById("modal_total").innerText = parseInt(rental_cost + end_surcharge);

      // let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;
      // if (hours > 0 && hours < car.hours_limit) {
      //   document.getElementById("modal_total").innerText = parseInt(rental_cost + (car.price_hour * hours) + end_surcharge);
      // }
    } else {
      if (end_location && parseInt(end_location.price) > 0) {
        document.getElementById("modal_for_location_end").classList.remove("hidden");
        document.getElementById("modal_for_location_end_price").innerText = end_location.price;

        document.getElementById("modal_total").innerText = parseInt(rental_cost + parseInt(end_location.price));

        // let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;
        // if (hours > 0 && hours < car.hours_limit) {
        //   document.getElementById("modal_total").innerText = parseInt(rental_cost + (car.price_hour * hours) + parseInt(end_location.price));
        // }
      } else {
        document.getElementById("modal_for_location_end_price").innerText = 0;
        document.getElementById("modal_for_location_end").classList.add("hidden");
        document.getElementById("modal_total").innerText = rental_cost;

        // let hours = dayjs(`${end_date} ${end_time}`, "YYYY-MM-DD H:mm").diff(dayjs(`${start_date} ${start_time}`, "YYYY-MM-DD H:mm"), 'hours') % 24;
        // if (hours > 0 && hours < car.hours_limit) {
        //   document.getElementById("modal_total").innerText = parseInt(rental_cost + (car.price_hour * hours));
        // }
      }
    }
  }
  toReservation() {
    document.getElementById("reservationModal").classList.remove("hidden");
  }
  // Cтраховка
  full_insurance(event) {
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    if (car.insurance_settings.full.on) {
      let daily_price = parseInt(car.insurance_settings.full.price);
      let all_days = parseInt(document.getElementById("modal_nights").textContent);
      let total_insurance = parseInt(all_days * daily_price);
      let total = parseInt(document.getElementById("modal_total").textContent);
      if (document.getElementById("full_insurance").checked) {
        document.getElementById("modal_full_insurance_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total + total_insurance;
        document.getElementById("modal_full_insurance").classList.remove("hidden");
      } else {
        document.getElementById("modal_full_insurance_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total - total_insurance;
        document.getElementById("modal_full_insurance").classList.add("hidden");
      }
    } else {
      event.preventDefault();
      document.getElementById("full_insurance").checked = false;
      document.getElementById("full_insurance").disabled = true;
    }
  }
  super_kasko(event) {
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    if (car.insurance_settings.super_kasko.on) {
      let daily_price = parseInt(car.insurance_settings.super_kasko.price);
      let all_days = parseInt(document.getElementById("modal_nights").textContent);
      let total_insurance = parseInt(all_days * daily_price);
      let total = parseInt(document.getElementById("modal_total").textContent);
      if (document.getElementById("super_kasko").checked) {
        document.getElementById("modal_super_kasko_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total + total_insurance;
        document.getElementById("modal_super_kasko").classList.remove("hidden");
      } else {
        document.getElementById("modal_super_kasko_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total - total_insurance;
        document.getElementById("modal_super_kasko").classList.add("hidden");
      }
    } else {
      event.preventDefault();
      document.getElementById("super_kasko").checked = false;
      document.getElementById("super_kasko").disabled = true;
    }
  }
  kasko(event) {
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    if (car.insurance_settings.kasko.on) {
      let daily_price = parseInt(car.insurance_settings.kasko.price);
      let all_days = parseInt(document.getElementById("modal_nights").textContent);
      let total_insurance = parseInt(all_days * daily_price);
      let total = parseInt(document.getElementById("modal_total").textContent);
      if (document.getElementById("kasko").checked) {
        document.getElementById("modal_kasko_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total + total_insurance;
        document.getElementById("modal_kasko").classList.remove("hidden");
      } else {
        document.getElementById("modal_kasko_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total - total_insurance;
        document.getElementById("modal_kasko").classList.add("hidden");
      }
    } else {
      event.preventDefault();
      document.getElementById("kasko").checked = false;
      document.getElementById("kasko").disabled = true;
    }
  }
  theft(event) {
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    if (car.insurance_settings.theft.on) {
      let daily_price = parseInt(car.insurance_settings.theft.price);
      let all_days = parseInt(document.getElementById("modal_nights").textContent);
      let total_insurance = parseInt(all_days * daily_price);
      let total = parseInt(document.getElementById("modal_total").textContent);
      if (document.getElementById("theft").checked) {
        document.getElementById("modal_theft_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total + total_insurance;
        document.getElementById("modal_theft").classList.remove("hidden");
      } else {
        document.getElementById("modal_theft_total").innerText = total_insurance;
        document.getElementById("modal_total").innerText = total - total_insurance;
        document.getElementById("modal_theft").classList.add("hidden");
      }
    } else {
      event.preventDefault();
      document.getElementById("theft").checked = false;
      document.getElementById("theft").disabled = true;
    }
  }
  // Services
  calcServices(event) {
    let total = parseInt(document.getElementById("modal_total").textContent);
    let services = document.querySelectorAll(".service");
    let total_services = document.getElementById("modal_services_total").textContent ? parseInt(document.getElementById("modal_services_total").textContent) : 0;
    let days = parseInt(document.getElementById("modal_nights").textContent);
    if (services.length > 0) {
      if (event.target.checked) {
        if (event.target.dataset.daily == "true") {
          total += parseInt(event.target.dataset.price) * days;
          total_services += parseInt(event.target.dataset.price) * days;
        } else {
          total += parseInt(event.target.dataset.price);
          total_services += parseInt(event.target.dataset.price);
        }
        document.getElementById("modal_total").innerText = total + total_services;
      } else {
        if (event.target.dataset.daily == "true") {
          total -= parseInt(event.target.dataset.price) * days;
          total_services -= parseInt(event.target.dataset.price) * days;
        } else {
          total -= parseInt(event.target.dataset.price);
          total_services -= parseInt(event.target.dataset.price);
        }
      }
      console.log(total_services)
      document.getElementById("modal_services_total").innerText = total_services;
      document.getElementById("modal_total").innerText = total;
      document.getElementById("modal_services_total").classList.remove("hidden");
      document.getElementById("modal_services").classList.remove("hidden");
    } else {
      document.getElementById("modal_services_total").classList.add("hidden");
      document.getElementById("modal_services").classList.add("hidden");
    }
  }
  // Phones
  changeCountryPhone() {
    document.getElementById("rus_phone").classList.toggle('hidden');
    document.getElementById("estrangeiro_phone").classList.toggle('hidden');
  }
  // modal
  // Точки выдачи и возврата компании. У части компаний их нет вовсе (Rollbar
  // 03.10.2026, машина 69982: locations = []), а поле может и не прийти.
  locations(car) {
    return (car.booking_settings && car.booking_settings.locations) || []
  }

  // Доплата за выдачу или возврат вне рабочего времени для найденной точки.
  //
  // Точки может не найтись: у компании их нет вовсе или имя выбранной не
  // совпало со списком. Тогда доплаты нет и строка скрыта — так же, как ветка
  // рабочего времени (selectStartLocation / selectEndLocation) уже поступает с
  // отсутствующей точкой. Раньше здесь разыменовывался undefined: падал
  // connect, а кнопка «Забронировать» не открывала окно вовсе.
  applyAfterHoursSurcharge(location, rowId, priceId) {
    const row = document.getElementById(rowId)
    const price = document.getElementById(priceId)
    if (!location) {
      row.classList.add("hidden")
      price.innerText = 0
      return 0
    }
    const surcharge = parseInt(location.extra_price) || 0
    row.classList.remove("hidden")
    price.innerText = surcharge
    return surcharge
  }

  open(event) {
    if (event) {
      event.preventDefault();
    }
    // scroll to top modal
    document.getElementById("reservation_modal").scrollTop = 0;
    // Меняем z-index у слайдера
    let slider_elements = document.getElementsByClassName("splide__arrow")
    let slider_elements_rings = document.getElementsByClassName("splide__pagination")
    Array.from(slider_elements).forEach((el) => {
      el.style.zIndex = "0";
    });
    Array.from(slider_elements_rings).forEach((el) => {
      el.style.zIndex = "0";
    });
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    let start_date = document.getElementById("start_date").value;
    let end_date = document.getElementById("end_date").value;
    let start_time = document.getElementById("start_time").value;
    let end_time = document.getElementById("end_time").value;
    let start_date_full = `${start_date} ${start_time}`;
    let end_date_full = `${end_date} ${end_time}`;
    document.getElementById("modal_selected_price").innerText = document.getElementById("selected_price").textContent;
    document.getElementById("modal_nights").innerText = document.getElementById("nights").textContent;
    document.getElementById("modal_for_rent").innerText = document.getElementById("for_rent").textContent;
    document.getElementById("modal_total").innerText = document.getElementById("total").textContent;
    document.getElementById("modal_to_pay").innerText = document.getElementById("to_pay").textContent;
    document.getElementById("modal_to_pay_now").innerText = document.getElementById("to_pay_now").textContent;

    let paid_hours = document.getElementById("paid_hours").textContent
    console.log("paid_hours", paid_hours)
    if (paid_hours && parseInt(paid_hours) > 0) {
      document.getElementById("modal_hours_calc").classList.remove("hidden");
      document.getElementById("modal_price_hour").innerText = document.getElementById("price_hour").textContent;
      document.getElementById("modal_paid_hours").innerText = paid_hours;
      document.getElementById("modal_for_paid_hours").innerText = document.getElementById("for_paid_hours").textContent;
      document.getElementById("modal_total").innerText = document.getElementById("total").textContent;
      document.getElementById("modal_to_pay").innerText = document.getElementById("to_pay").textContent;
      document.getElementById("modal_to_pay_now").innerText = document.getElementById("to_pay_now").textContent;
    }

    // // обнуляем локации ! Обнуляет если есть выдача и возврат вне рабочего времени
    // this.start_locationTarget.value = "Офис";
    // document.getElementById("modal_for_location_start_price").innerText = "0";
    // this.end_locationTarget.value = "Офис";
    // document.getElementById("modal_for_location_end_price").innerText = "0";
    // Рабочее время
    // Create your Business Week definition
    const business_time = car.booking_settings.business_time
    // Set Business Times in dayjs
    dayjs.setBusinessTime(business_time);

    if (!(dayjs(start_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
      let start_location
      let start_location_name = document.getElementById("start_location").value
      if (start_location_name != "") {
        start_location = this.locations(car).find((item) => item.name == start_location_name)
      } else {
        start_location = this.locations(car).find((item) => item.name == "Офис")
      }
      const start_surcharge = this.applyAfterHoursSurcharge(start_location, "modal_for_location_start", "modal_for_location_start_price");
      document.getElementById("modal_total").innerText = parseInt(document.getElementById("modal_total").textContent) + start_surcharge;
    }
    if (!(dayjs(end_date_full, "YYYY-MM-DD H:mm").isBusinessTime())) {
      let end_location
      let end_location_name = document.getElementById("end_location").value
      if (end_location_name != "") {

        end_location = this.locations(car).find((item) => item.name == end_location_name)
      } else {
        end_location = this.locations(car).find((item) => item.name == "Офис")
      }
      const end_surcharge = this.applyAfterHoursSurcharge(end_location, "modal_for_location_end", "modal_for_location_end_price");
      console.log("end_location", document.getElementById("modal_for_location_end_price"))
      document.getElementById("modal_total").innerText = parseInt(document.getElementById("modal_total").textContent) + end_surcharge;
    }
    // обнуляем услуги
    let services = document.querySelectorAll(".service");
    if (services.length > 0) {
      Array.from(services).forEach((el) => {
        el.checked = false;
      });
    }
    // обнуляем страховку
    let full_insurance = document.getElementById("full_insurance");
    full_insurance.checked = false;
    document.getElementById("modal_full_insurance_total").innerText = "0";
    document.getElementById("modal_full_insurance").classList.add("hidden");
    let super_kasko = document.getElementById("super_kasko");
    super_kasko.checked = false;
    document.getElementById("modal_super_kasko_total").innerText = "0";
    document.getElementById("modal_super_kasko").classList.add("hidden");
    let kasko = document.getElementById("kasko");
    kasko.checked = false;
    document.getElementById("modal_kasko_total").innerText = "0";
    document.getElementById("modal_kasko").classList.add("hidden");
    let theft = document.getElementById("theft");
    theft.checked = false;
    document.getElementById("modal_theft_total").innerText = "0";
    document.getElementById("modal_theft").classList.add("hidden");



    // Пересчитываем модульное окно
    // this.selectStartLocation();
    // this.selectEndLocation();

    document.getElementById("reservation_modal").classList.remove("hidden");
  }

  backdropClick(event) {
    event.target === this.reservationModalTarget && this.close(event)
  }

  close(event) {
    event.preventDefault();
    // Меняем z-index у слайдера, костыль
    let slider_elements = document.getElementsByClassName("splide__arrow")
    let slider_elements_rings = document.getElementsByClassName("splide__pagination")
    Array.from(slider_elements).forEach((el) => {
      el.style.zIndex = "1";
    });
    Array.from(slider_elements_rings).forEach((el) => {
      el.style.zIndex = "1";
    });
    console.log("close")
    document.getElementById("reservation_modal").classList.add("hidden");
  }

  toPayments(event) {
    event.preventDefault();
    let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
    let lastname = document.getElementById("lastname").value;
    let name = document.getElementById("name").value;
    let surname = document.getElementById("surname").value;
    let birthday = document.getElementById("birthday").value;
    let driver_from = document.getElementById("driver_from").value;
    let email = document.getElementById("email").value;
    let phone = document.getElementById("phone").value;
    let phone_external = document.getElementById("phone_external").value;
    let extra_phone = document.getElementById("extra_phone").value;

    let checkLastname = lastname != "" && lastname != " " && lastname != "  " && lastname != "   ";
    let checkName = name != "" && name != " " && name != "  " && name != "   ";
    let age_limit = car.age_limit ? car.age_limit : 25;
    let driver_year_limit = car.driver_year_limit ? car.driver_year_limit : 2;

    let checkBirthday = dayjs(birthday, 'DD.MM.YYYY').isValid() && dayjs(birthday, 'DD.MM.YYYY').isBefore(dayjs().subtract(age_limit, 'year'));
    let checkDriver_from = parseInt(driver_from) >= driver_year_limit;
    let checkEmail = validator.isEmail(email);
    let checkPhone = true;

    if (!document.getElementById("terms").checked) {
      document.getElementById("terms").focus();
      document.getElementById("terms").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    }
    if (!document.getElementById("privacy").checked) {
      document.getElementById("privacy").focus();
      document.getElementById("privacy").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    }
    if (!checkPhone) {
      document.getElementById("phone").focus();
      document.getElementById("phone").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    }
    if (!checkEmail) {
      document.getElementById("email").focus();
      document.getElementById("email").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    }
    if (!checkBirthday) {
      console.log("checkBirthday", validator.isDate(birthday, [{ format: 'DD.MM.YYYY' }]), birthday)
      document.getElementById("birthday").focus();
      document.getElementById("birthday").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
      Swal.fire({
        title: 'Внимание!',
        text: `Согласно нашим условиям аренды, возраст водителя должен быть не менее ${age_limit}.`,
        icon: 'warning',
        confirmButtonText: 'OK'
      })
      return
    }
    if (!checkDriver_from) {
      document.getElementById("driver_from").focus();
      document.getElementById("driver_from").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
      Swal.fire({
        title: 'Внимание!',
        text: `Согласно нашим условиям аренды, водитель должен иметь водительский стаж не менее ${driver_year_limit} лет.`,
        icon: 'warning',
        confirmButtonText: 'OK'
      })
      return
    }
    if (!checkLastname) {
      document.getElementById("lastname").focus();
      document.getElementById("lastname").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    }
    if (!checkName) {
      document.getElementById("name").focus();
      document.getElementById("name").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    }
    // if (!checkSurname) {
    //   document.getElementById("surname").focus();
    //   document.getElementById("surname").classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500");
    // }

    if (checkLastname && checkName && checkBirthday && checkEmail && checkPhone && document.getElementById("privacy").checked && document.getElementById("terms").checked) {
      try {
        // document.getElementById("reservation_loader").classList.remove("hidden");
        // let search_params = new URLSearchParams(window.location.search);
        let car = JSON.parse(document.getElementById("reservation_form").dataset.car);
        let days = parseInt(document.getElementById("modal_nights").textContent);
        let hours = parseInt(document.getElementById("modal_paid_hours").textContent || 0);
        let price = car.selected_price;
        let price_hour = car.price_hour;
        let hours_cost = parseInt(document.getElementById("modal_for_paid_hours").textContent || 0);
        let total = parseInt(document.getElementById("modal_total").textContent);
        let to_pay_now = parseInt(document.getElementById("modal_to_pay_now").textContent);
        let total_without_fee = total - to_pay_now;
        let fast_booking = car.fast_booking;
        let location_start = this.start_locationTarget.value;
        let location_end = this.end_locationTarget.value;
        // Insurance
        let insurance_cost = 0;
        if (document.getElementById("modal_full_insurance_total")) {
          insurance_cost += parseInt(document.getElementById("modal_full_insurance_total").textContent || 0);
        }
        if (document.getElementById("modal_full_insurance_total")) {
          insurance_cost += parseInt(document.getElementById("modal_super_kasko_total").textContent || 0);
        }
        if (document.getElementById("modal_full_insurance_total")) {
          insurance_cost += parseInt(document.getElementById("modal_kasko_total").textContent || 0);
        }
        if (document.getElementById("modal_theft_total")) {
          insurance_cost += parseInt(document.getElementById("modal_theft_total").textContent || 0);
        }

        // Locations
        let checkin_cost = 0;
        if (document.getElementById("modal_for_location_start_price") && parseInt(document.getElementById("modal_for_location_start_price").textContent) > 0) {
          checkin_cost = parseInt(document.getElementById("modal_for_location_start_price").textContent || 0);
        }
        let checkout_cost = 0;
        if (document.getElementById("modal_for_location_end_price") && parseInt(document.getElementById("modal_for_location_end_price").textContent) > 0) {
          checkout_cost = parseInt(document.getElementById("modal_for_location_end_price").textContent || 0);
        }
        // services
        let services = document.getElementsByClassName('service');
        let services_values = [];
        for (let i = 0; i < services.length; i++) {
          if (services[i].checked) {
            services_values.push({ id: services[i].dataset.id, name: services[i].dataset.name, price: services[i].dataset.price });
          }
        }
        let services_cost = 0;
        if (document.getElementById("modal_services_total") && parseInt(document.getElementById("modal_services_total").textContent) > 0) {
          services_cost = parseInt(document.getElementById("modal_services_total").textContent || 0);
        }

        // Insurance
        let full_insurance = document.getElementById("full_insurance").checked;
        let super_kasko = document.getElementById("super_kasko").checked;
        let kasko = document.getElementById("kasko").checked;
        let theft = document.getElementById("theft").checked;

        let start_date = document.getElementById("start_date").value;
        let end_date = document.getElementById("end_date").value;
        let start_time = document.getElementById("start_time").value;
        let end_time = document.getElementById("end_time").value;
        let start_date_full = `${start_date} ${start_time}`;
        let end_date_full = `${end_date} ${end_time}`;

        // description + extra phone
        let description = document.getElementById("client_description").value;
        let extra_phone = document.getElementById("extra_phone").value;
        if (extra_phone && extra_phone != "" && extra_phone != " " && extra_phone != null) {
          description += ` дополнительный телефон: ${extra_phone}`;
        }

        // Вставляем данные в форму
        document.getElementById("booking_start_date_value").value = start_date_full;
        document.getElementById("booking_end_date_value").value = end_date_full;
        document.getElementById("booking_car_id").value = car.id;
        document.getElementById("booking_car_name").value = car.car_name;
        document.getElementById("booking_car_year").value = car.year;
        document.getElementById("booking_client_lastname").value = lastname;
        document.getElementById("booking_client_name").value = name;
        document.getElementById("booking_client_surname").value = surname;
        document.getElementById("booking_client_birthday").value = birthday;
        document.getElementById("booking_driver_from").value = driver_from;
        document.getElementById("booking_email").value = email;
        document.getElementById("booking_phone").value = phone;
        document.getElementById("booking_extra_phone").value = extra_phone;
        document.getElementById("booking_phone_external").value = phone_external;
        document.getElementById("booking_selected_price").value = car.selected_price;
        document.getElementById("booking_days").value = days;
        document.getElementById("booking_hours").value = hours;
        document.getElementById("booking_price_hour").value = price_hour;
        document.getElementById("booking_price").value = price;
        document.getElementById("booking_hours_cost").value = hours_cost;
        document.getElementById("booking_total_cost").value = total;
        document.getElementById("booking_total_without_fee").value = total_without_fee;
        document.getElementById("booking_fast_booking").value = fast_booking;
        document.getElementById("booking_services").value = JSON.stringify(services_values);
        document.getElementById("booking_equipment_cost").value = services_cost;
        document.getElementById("booking_location_start").value = location_start;
        document.getElementById("booking_location_end").value = location_end;
        document.getElementById("booking_full_insurance").value = full_insurance;
        document.getElementById("booking_super_kasko").value = super_kasko;
        document.getElementById("booking_kasko").value = kasko;
        document.getElementById("booking_theft").value = theft;
        document.getElementById("booking_insurance_cost").value = insurance_cost;
        document.getElementById("booking_checkin_cost").value = checkin_cost;
        document.getElementById("booking_checkout_cost").value = checkout_cost;
        document.getElementById("booking_commission").value = to_pay_now;
        document.getElementById("booking_deposit").value = car.deposit;
        document.getElementById("booking_client_description").value = description;

        this.bookingFormTarget.submit();
      } catch (error) {
        // document.getElementById("reservation_loader").classList.add("hidden");
        console.log(error);
        alert(error);
      }
    } else {
      if ((!document.getElementById("privacy").checked || !document.getElementById("terms").checked) && (checkName && checkBirthday && checkEmail && checkPhone)) {
        Swal.fire({
          title: 'Ошибка!',
          text: 'Необходимо согласиться с условиями и политикой конфиденциальности',
          icon: 'error',
          confirmButtonText: 'OK'
        })
        // alert("Вы должны согласиться с условиями и политикой конфиденциальности");
      } else {
        Swal.fire({
          title: 'Ошибка!',
          text: 'Проверьте правильность заполнения полей',
          icon: 'error',
          confirmButtonText: 'OK'
        })
        // alert("Проверьте правильность заполнения полей");
      }
    }
  }

  clearErrors(event) {
    event.target.classList.remove("border-red-500", "focus:border-red-500", "focus:ring-red-500");
  }
}
